import Vue from 'vue'

import {
  LANGUAGE
} from '@/store/variables'

const app = {
  stat: {
    language: ''
  },
  mutations: {
    TOGGLE_LANGUAGE: (state, language) => {
      state.language = language
      Vue.ls.set(LANGUAGE, language)
    }
  },
  actions: {
    ToggleLanguage ({ commit }, language) {
      commit('TOGGLE_LANGUAGE', language)
    }
  }
}

export default app
